import {
    ReactNode,
    // useRef,
} from 'react'
import {
    Root,
    Trigger,
    Portal,
    Content,
    Overlay,
    Title,
    Close,
} from '@radix-ui/react-dialog'
// import { useResizeObserver } from 'usehooks-ts'

import { VkOrdHistoryResponse } from '@synapex/shared2/gateway-rest-api'

import CloseIcon from './CloseIcon.svg?react'
import classes from './EventsDialog.module.scss'
import { Table } from './Table'

import { MARKING_DIALOG_LAYOUT } from '../../../components/shared/MarkingPartLayout/data'

const OVERLAY_STYLE = {
    right: 0,
    left: 'auto',
    width: MARKING_DIALOG_LAYOUT.totalWidth,
}

const CONTENT_STYLE = {
    left: 'auto',
    width: MARKING_DIALOG_LAYOUT.eventsModal.totalWidth,
    right:
        (MARKING_DIALOG_LAYOUT.totalWidth -
            MARKING_DIALOG_LAYOUT.eventsModal.totalWidth) /
        2,
    '--tw-translate-x': 0,
}

export type EventsDialogProps = {
    trigger: ReactNode
    vkOrdHistory: VkOrdHistoryResponse[]
}
export const EventsDialog = ({ trigger, vkOrdHistory }: EventsDialogProps) => {
    return (
        <Root>
            <Trigger asChild>{trigger}</Trigger>
            <Portal>
                <Overlay className={classes.overlay} style={OVERLAY_STYLE} />
                <Content
                    aria-describedby={undefined}
                    className={classes.content}
                    style={CONTENT_STYLE}
                >
                    <Close autoFocus={false} className={classes.close}>
                        <CloseIcon />
                    </Close>
                    <Title className={classes.title}>
                        Последние события из ОРД
                    </Title>
                    <Table vkOrdHistory={vkOrdHistory} />
                </Content>
            </Portal>
        </Root>
    )
}
